//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions } from 'vuex';
import constant from '~/const';
import tableConfig from './tableConfig';
import StatisticsTradeTurnoverP2PFilters from './StatisticsTradeTurnoverP2PFilters.vue';
import StatisticsTradeTurnoverP2PChart from './StatisticsTradeTurnoverP2PChart.vue';

export default {
  components: {
    StatisticsTradeTurnoverP2PFilters,
    StatisticsTradeTurnoverP2PChart,
  },
  data() {
    return {
      constant,
      tableConfig,
      loader: false,
    };
  },

  computed: {
    ...mapState('common', ['generalLoader']),
    ...mapState('statisticsTradeTurnover', ['amounts', 'chart', 'currentCurrencyId']),
  },

  async created() {
    this.setGeneralProgress(true);
    this.loader = true;
    await Promise.allSettled([
      this.loadDataAction(),
      this.loadChartAction(),
    ]);
    this.loader = false;
    this.setGeneralProgress(false);
  },

  methods: {
    ...mapActions('common', [
      'setGeneralLoader',
      'setGeneralProgress',
      'setSuccessNotification',
      'setErrorNotification',
      'confirmAction',
    ]),

    ...mapActions('statisticsTradeTurnover', {
      loadChartAction: 'loadChart',
      loadDataAction: 'loadData',
    }),

    async applyFilters() {
      this.setGeneralProgress(true);
      this.loader = true;
      await this.loadDataAction();
      this.setGeneralProgress(false);
      this.loader = false;
    },
  },
};
